import React from 'react'
import { Helmet } from 'react-helmet'
import { FaGithub } from 'react-icons/fa'
import { ProjObjMain, ProjObjFive, ProjObjFour, ProjObjOne, ProjObjThree, ProjObjTwo, ProjObjSix } from '../Data'
import './project.css'

function Project() {
    return (
        <>
            <div className="home__hero-section" id="project">
                <Helmet>
                    <title>Haris Khan | Projects</title>
                </Helmet>
                <h1 className="head--title">Projects</h1>
                <div className="line"></div>
                <div className="home__hero-container">
                    <Showcase {...ProjObjSix} />
                    <Showcase {...ProjObjMain} />
                    <Showcase {...ProjObjOne} />
                    <Showcase {...ProjObjTwo} />
                    <Showcase {...ProjObjThree} />
                    <Showcase {...ProjObjFour} />
                    <Showcase {...ProjObjFive} />
                </div>
            </div>
        </>
    )
}

function Showcase({
    headline,
    description,
    buttonLabel,
    img,
    alt,
    DemoLink,
    GithubLink
}){
    return(
            <div className="home__hero_Box">
                <div className='home_hero-col'>
                    <div className='home__hero-text-wrapper'>
                        <h1 className='heading'>
                            {headline}
                        </h1>
                        <p className='home__hero-subtitle'>
                            {description}
                        </p>
                        <div className="home__hero-btns">
                            <a 
                                href={DemoLink} 
                                target='_blank' 
                                rel="noopener noreferrer"
                            >
                                <span className="btn">
                                    {buttonLabel}
                                </span>
                            </a>
                            <a 
                                href={GithubLink} 
                                target='_blank' 
                                rel="noopener noreferrer"
                            >
                                <span className="btn">
                                    <FaGithub /> Github
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="home_hero-col">
                    <div className="home__hero-img-wrapper">
                        <img src={img} alt={alt} className="home__hero-img" />
                    </div>
                </div>
            </div>
    )
}

export default Project